import { Component, OnInit, ViewChild } from '@angular/core';
import { ElementRef } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { CommonService } from 'src/app/services/common.service';
import { APIService } from 'src/app/api.service';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';


@Component({
  selector: 'app-rpt-prd-prod-wise-manufacturing',
  templateUrl: './rpt-prd-prod-wise-manufacturing.component.html',
  styleUrls: ['./rpt-prd-prod-wise-manufacturing.component.scss']
})



export class RptPrdProdWiseManufacturingComponent implements OnInit {

  //Table sort and column
  displayedColumns: string[] = ['PrdName', 'PrdCode', 'CntJobs', 'StdPrd', 'AvgPrd', 'OnTime', 'LaunchQty', 'ComplnQty', 'Unit', 'Rejection'];
  dataSource = new MatTableDataSource();

  @ViewChild('mtlAviaTable', { static: false }) mtlAviaTable!: ElementRef;

  @ViewChild(MatPaginator)
  set paginator(value: MatPaginator) {
    this.dataSource.paginator = value;
  }

  @ViewChild(MatSort) set matSort(sort: MatSort) {
    this.dataSource.sort = sort;
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.matSort;
  }

  //Variable Declaration
  agencyData: any = [];
  jarvisData: any = [];
  materialAvailabilityList: any = [];
  exportToExcel: any = [];
  unitList:any = [];
  productList:any = [];
  date = new Date();
  curDate: any = new Date();
  selectedFY: any;
  fromDate: Date = new Date('2021-Apr-01');
  toDate: Date = new Date('2022-Mar-31');
  acctStartDT: Date = new Date();
  month = this.curDate.getMonth() + 1;
  year = this.curDate.getFullYear();
  lastMonth: any = new Date(new Date().getFullYear(), new Date().getMonth() + 0, 1);
  startDate: any = new Date(new Date(this.lastMonth));
  endDate: any = new Date(new Date());
  period: any = 1;

  unit = {
    uID: 0,
    uNm: ""
  };

  product = {
    prodID: 0,
    name: '',
    qty: ''
  }

  months:any = '';
  monthDisplay: any = '';


  constructor(private router: Router, private apiService: APIService, public CmnService: CommonService, private SpinnerService: NgxSpinnerService) { }

  ngOnInit(): void {
   this.months = this.CmnService.getMonthYear(new Date('2020-10-01').customFormat("#DD#-#MMM#-#YY#"), new Date().customFormat("#DD#-#MMM#-#YY#"));
   this.months = this.months.reverse();
   this.monthDisplay = this.months[0].display;
 
   this.dataSource.data = this.materialAvailabilityList;
   console.log(this.dataSource.data)
     this.getData();
  }

 
 //typeFilter() - 
 typeFilter = (obj: any) => {
   this.period = obj;
   if (this.period == 1) {
     this.trasYearChange();
   }
   else if(this.period == 2) {
     this.startDate = new Date(this.year + '-' + this.month + "-01");
     this.endDate = new Date(this.year, this.month, 0);
   }
   //this.getData();
 }

 //fn_ChangeDate() - 
 fn_ChangeDate() {
   this.year = new Date(this.startDate).customFormat('#YYYY#');
   this.month = new Date(this.startDate).customFormat('#MM#');
   this.getData();
 }

 //monthDiff() - 
 monthDiff(dateFrom: Date, dateTo: Date) {
   return dateTo.getMonth() - dateFrom.getMonth() + 
     (12 * (dateTo.getFullYear() - dateFrom.getFullYear()))
 }

 trasYearChange() {
   let selecetdYear = this.months.filter((a: any) => a.display == this.monthDisplay);
   this.year = selecetdYear[0].year;
   this.month = selecetdYear[0].number;
   this.getData();
 };


  //Get Data - Call API
  getData() {
   debugger
    let agencyData = this.apiService.getCookie('M');
    if (agencyData) {
      this.agencyData = JSON.parse(agencyData);
    }

    var jarvis = this.apiService.getCookie('Jarvis');
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    }
    let data = [
     {
       Month: this.month,
       Year: this.year
     }
   ];
    let myParams = [
      {
        myUserID: this.jarvisData[0].UserID,
        myToken: this.jarvisData[0].WebToken,
        forAgencyID: this.jarvisData[0].AgencyIDs,
        myAgencyIDs: this.jarvisData[0].AgencyIDs,
        myLastSyncDT: null,
        isWeb: true,
        ForERPAgencyID: this.agencyData[0].ERPAgencyID,
        actionType: 'getProductWiseMfgAnalysis',
        moduleID: 8,
        data: JSON.stringify(data),
      },
    ];
    this.SpinnerService.show();
    this.apiService.getData(myParams, this.successResp.bind(this), this.failureResp.bind(this)
    );
  }

  //Success Response - Success handler
  successResp(res: any) {
    this.SpinnerService.hide();
    if (res.error) {
    }
    else {
      if (res) {
        var reponseData = JSON.parse(res.updatePackage);
        if (reponseData.Table[0].ErrCode == 1000) {
          alert(reponseData.Table[0].ErrMsg);
          window.location.href = "main.html#/home";
        } else {
          if (reponseData.Table[0].ErrCode == -1) {
            this.materialAvailabilityList = reponseData.Table1;

            this.materialAvailabilityList.forEach((p: any) => {
             p.LaunchQty = Number(p.LaunchQty).toFixed(p.Prcsn);
             p.ComplnQty = Number(p.ComplnQty).toFixed(p.Prcsn);


             if(p.LaunchQty == 0 && p.RejQty == 0){
               p.Rejection = 0;
             }
             else{
               p.Rejection = (p.RejQty / p.LaunchQty) * 100 ;
               p.Rejection = p.Rejection.toFixed(0);
             }
           })

            console.log(this.materialAvailabilityList)
            this.dataSource.data = this.materialAvailabilityList;
            this.dataSource.data = this.dataSource.data.sort((a: any, b: any) => a.PrdName.localeCompare(b.PrdName))
            this.exportToExcel = this.materialAvailabilityList;
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.matSort;
          }
        }
      }
    }
  }

  //failureResp - failure handler
  failureResp(res: any) {
    if (res.error) {
    } else {
      alert(res.message);
    }
  }

  //search
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

 //export to excel
 tableToExcel = (function () {
   var uri = 'data:application/vnd.ms-excel;base64,'
     , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body>{table}</body></html>'
     , base64 = function (s: any) { return window.btoa(unescape(encodeURIComponent(s))) }
     , format = function (s: any, c: any) { return s.replace(/{(\w+)}/g, function (m: any, p: any) { return c[p]; }) }

   return function (table: any, name: string, fileName: any) {
     if (!table.nodeType) table = table
     var ctx = { worksheet: name || 'Worksheet', table: table }
     //window.location.href = uri + base64(format(template, ctx))
     var link = document.createElement("a");
     link.download = fileName || 'download.xls';
     link.href = uri + base64(format(template, ctx));
     link.click();
   }
 })()

 //export to excel
exportToExcelActivities() {
 debugger
     var html = "";
     html += "<table><tr>";
     html += "<th style='text-align: left;'>Product-wise Manufacturing Analysis	</th>"
     html += "</table></tr>";
     html += "<table><tr></table></tr>";
     html += "</table></tr>";
     html += "</table></tr>";
     
     html += "<p><b>  Month : </b>"+ this.monthDisplay +  "</p>"
     // Blank Column
     html += "<table><tr></table></tr>";
     html += "<table><tr>";

 var strHeader = ""
 strHeader += "<th style='text-align: left;'>Product</th>";
 strHeader += "<th style='text-align: left;'>Code</th>";
 strHeader += "<th style='text-align: right;'>Jobs</th>";
 strHeader += "<th style='text-align: left;'>Std Period</th>";
 strHeader += "<th style='text-align: left;'>Avg Period</th>";
 strHeader += "<th style='text-align: left;'>Punctuality</th>";
 strHeader += "<th style='text-align: right;'>Launch</th>";
 strHeader += "<th style='text-align: right;'>Completion</th>";
 strHeader += "<th style='text-align: right;'>Unit</th>";
 strHeader += "<th style='text-align: left;'>Rejection</th>";

 strHeader += "</tr>"
 html += strHeader;
 // displayedColumns: string[] = ['PrdName', 'PrdCode', 'CntJobs', 'StdPrd', 'AvgPrd', 'OnTime', 'LaunchQty', 'ComplnQty', 'Unit', 'Rejection'];

 var body = "";
 this.exportToExcel.forEach((itemData:any, key:any) => {
   body += "<tr>";
   body += "<td style='text-align: left;'>" + itemData.PrdName +  "</td>";
   body += "<td style='text-align: left;'>" + (itemData.PrdCode) + "</td>";
   body += "<td style='text-align: right;'>" + (itemData.CntJobs) + "</td>";
   body += "<td style='text-align: left;'>" + itemData.StdPrd + 'days'+ "</td>";
   body += "<td style='text-align: left;'>" + itemData.AvgPrd + 'days' + "</td>";
   body += "<td style='text-align: left;'>" + itemData.OnTime +'%' + "</td>"
   body += "<td style='text-align: right;'>" + itemData.LaunchQty  + "</td>";
   body += "<td style='text-align: right;'>" + itemData.ComplnQty  + "</td>";
   body += "<td style='text-align: left;'>" + itemData.Unit  + "</td>"
   body += "<td style='text-align: right;'>" + itemData.Rejection +'%' + "</td>"

  
 body += "</tr>";
 })


 html += body;
 html += "</table>";
 this.tableToExcel(html, 'Sheet1', 'Product-wise Manufacturing Analysis');
}

backBtn() {
 this.router.navigate(['/ProductionList']);
}

}

